import { UnleashClient } from 'unleash-proxy-client'
import Config from '@/config'
import sentry from './sentry'

class UnleashService {
  constructor() {
    try {
      this.unleashClient = new UnleashClient({
        url: 'https://features.ahaslides.com/api/proxy',
        clientKey: Config.unleashClientKey,
        appName: 'presenter',
        createAbortController: () => null,
        // This is the on-update function for real-time updates from Unleash to continuously refresh feature flags from the Unleash server.
        // Developers should carefully consider which features to use with this function, as it needs to handle cases where a feature might be toggled on or off while users are actively using it.
        // Additionally, there may be unforeseen cases to account for.
        refreshInterval: 0,
      })
    } catch (error) {
      sentry.captureException(error)
      this.unleashClient = null
    }
  }

  start() {
    this.unleashClient.start()
  }

  isFeatureEnabled(featureName) {
    if (!this.unleashClient) {
      return false
    }

    try {
      return this.unleashClient.isEnabled(featureName)
    } catch (error) {
      return false
    }
  }

  getVariant(featureName) {
    if (!this.unleashClient) {
      return { name: 'disabled', enabled: false }
    }

    try {
      return this.unleashClient.getVariant(featureName)
    } catch (error) {
      return { name: 'disabled', enabled: false }
    }
  }
}

export default new UnleashService()
